import React from 'react';

import { VirtualConnectionTablesByIdQueryVariables, VirtualConnectionTablesByIdQuery, VirtualConnectionTableSortOrder, TablesDisplayGridRowData_VirtualConnectionTable_Fragment , VirtualConnectionTablesByIdDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '../../../data-catalog-shared';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { getRowDataWithMaxCountsForVirtualConnectionTable } from '../table/functions/VirtualConnectionTableRowDataFunctions';
import { VirtualConnectionTablesDisplayGridRowData } from '../table/types/VirtualConnectionTablesDisplayGridRowData';
import {
  VirtualConnectionTablesDisplayGrid,
} from './VirtualConnectionTablesDisplayGrid';

export type QueryVariables = VirtualConnectionTablesByIdQueryVariables;
export type QueryResults = VirtualConnectionTablesByIdQuery;
export type QueryResultListNode = TablesDisplayGridRowData_VirtualConnectionTable_Fragment;
export type GridRowData = VirtualConnectionTablesDisplayGridRowData;

export type VirtualConnectionTablesQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<FieldsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnections && resultData.virtualConnections[0] &&
    resultData.virtualConnections[0].tablesConnection;
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.virtualConnections && resultData.virtualConnections[0];
}

function getRowDataForVirtualConnectionTable(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  return getRowDataWithMaxCountsForVirtualConnectionTable(node, selectMaxCountsResult(resultData));
}

export function VirtualConnectionTablesQueryGrid(props: VirtualConnectionTablesQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTablesByIdDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as unknown as VirtualConnectionTableSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnectionTable}
    >
      {({ rowStore }) => (
        <VirtualConnectionTablesDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
